module.exports = __webpack_public_path__ + "static/media/login_bg.8f5e53e1.jpg";